<template>
    <div>

      <v-row>
        <v-col class="text-center">
          <span  style="font-size:20px;font-weight:bold;"><span class="service">{{service.name}}</span> ok!
          <br>
          Quando vorresti venire<br> nel nostro salone! </span>
        </v-col>
      </v-row>

      <steps v-bind:currentStep="step"/>

      <v-row>
        <v-col>
          <p class="text-center">2. Seleziona il <b>giorno</b> e l'<b>orario</b></p>
        </v-col>
      </v-row>

      <v-expansion-panels>
        <v-expansion-panel v-for="slot in slots" :key="slot.day">
          <v-expansion-panel-header style="font-size:16px;font-weight:bold;text-transform: capitalize;">{{slot.day | moment("dddd D MMMM ")}}</v-expansion-panel-header>
          <v-expansion-panel-content>

            <v-row dense>
                <v-col v-for="hour in slot.hours" :key="hour.pos" cols="12" lg="6" xs="12">
                    <v-card dark v-on:click="setSlot(slot.day,hour.time)">
                        <v-card-title class="headline" v-text="hour.time"></v-card-title>
                    </v-card>
                </v-col>
            </v-row>

          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <v-row style="margin-top:10px">
        <v-col cols="12" class="text-center">
          <strong>Non trovi la data e l'orario che fa per te?</strong>
          <v-btn block text outlined  href="tel:+390587735447"  ripple color="#000000" style="margin-top:10px;background-color:rgb(64, 211, 230)" @click="callUs()">CHIAMACI</v-btn>
        </v-col>
      </v-row>

    </div>
</template>

<script>

import axios from 'axios'
import steps from "../components/steps"
import { store, mutations } from "../store";

export default {
  name: 'Datelist',

  components: {
      steps
  },
  created() {
    mutations.completed = false
    axios.get(`${process.env.VUE_APP_API_ENDPOINT}/api/search?id=${this.service.id}`).then(
      response => {
        this.slots = response.data
      }).catch(() =>{
        this.$router.push("/error");  
      })
  },
  data: () => ({
    step:2,
    service: store.service,
    completed: store.components,
    slots:[]
  }),
  mounted(){
      if(!this.service){
          this.$router.push("/");
      }
  },
  methods:{
    setSlot: function(date, hour){
      mutations.setDate(date)
      mutations.setHour(hour)
      this.$router.push("/confirm");
    }    
  }
};
</script>

<style scoped>
.service{
  color:rgb(64, 211, 230);
}
</style>